type TableSchema = {
    [tableName: string]: {
        key: string | number;
        value: unknown;
    };
};

export class CacheManager<Tables extends TableSchema> {

    #memory: Map<keyof Tables, Map<Tables[keyof Tables]['key'], Tables[keyof Tables]['value']>>;

    constructor(tableNames: (keyof Tables)[]) {
        this.#memory = new Map();
        tableNames.forEach(tableName => this.#memory.set(tableName, new Map()));
    }

    get memory () { return this.#memory }

    addTable<TableName extends keyof Tables>(name: TableName): void {
        this.#memory.set(name, new Map());
    }

    dropTable<TableName extends keyof Tables>(name: TableName): void {
        this.#memory.delete(name);
    }

    get<TableName extends keyof Tables>(table: TableName, key: Tables[TableName]['key']): Tables[TableName]['value'] | undefined {
        if (!this.#memory.has(table)) throw new Error(`table ${String(table)} does not exist`);
        return this.#memory.get(table)!.get(key);
    }

    add<TableName extends keyof Tables>(name: TableName, key: Tables[TableName]['key'], item: Tables[TableName]['value']): void {
        const table = this.#memory.get(name)
        if (!table) throw new Error(`table ${String(name)} does not exist`);
        if (table.size > 20) table.clear()
        table.set(key, item);
    }

    delete<TableName extends keyof Tables>(table: TableName, key: Tables[TableName]['key']): void {
        if (!this.#memory.has(table)) return;
        this.#memory.get(table)!.delete(key);
    }
}